import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import AOS from 'aos';
import { FaArrowRight, FaSearch, FaPen, FaAd, FaEnvelope, FaInstagram, FaYoutube } from 'react-icons/fa';

const SERVICES = [
  { icon: <FaSearch />, title: 'SEO & SEM', desc: 'Dominate search rankings with data-driven SEO strategies and paid search campaigns.', color: '#1e40af' },
  { icon: <FaInstagram />, title: 'Social Media Marketing', desc: 'Build brand authority and drive engagement across all major social platforms.', color: '#7c3aed' },
  { icon: <FaPen />, title: 'Content Strategy', desc: 'Compelling content that educates, engages, and converts your target audience.', color: '#0891b2' },
  { icon: <FaAd />, title: 'Performance Campaigns', desc: 'ROI-focused paid campaigns on Google, Meta, LinkedIn, and more.', color: '#d97706' },
  { icon: <FaEnvelope />, title: 'Email Marketing', desc: 'Automated email sequences that nurture leads and drive customer retention.', color: '#059669' },
  { icon: <FaYoutube />, title: 'Video Marketing', desc: 'High-impact video content production and YouTube channel management.', color: '#dc2626' },
];

const PromoX = () => {
  useEffect(() => { AOS.init({ duration: 900, once: true, offset: 80 }); }, []);

  return (
    <div style={{ background: 'var(--color-bg)' }}>
      <section className="page-hero" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #3b0764 50%, #1e40af 100%)' }}>
        <div className="page-hero-overlay" />
        <Container>
          <div className="page-hero-content" data-aos="fade-up">
            <div className="breadcrumb-vk"><Link to="/">Home</Link> / <span>PromoX</span></div>
            <h1 className="page-hero-title">PromoX — <span>Digital Marketing & Growth</span></h1>
            <p className="page-hero-desc">
              Data-driven digital marketing that builds brands, captures audiences, and drives measurable business growth for forward-thinking companies.
            </p>
            <div style={{ display: 'flex', gap: '1rem', marginTop: '1.75rem', flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn-primary-vk">Grow Your Brand <FaArrowRight /></Link>
            </div>
          </div>
        </Container>
      </section>

      {/* Stats */}
      <section style={{ padding: '2.5rem 0', background: 'var(--color-bg)', borderBottom: '1px solid var(--color-border)' }}>
        <Container>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '1rem', textAlign: 'center' }}>
            {[
              ['3x', 'Average ROI', '#7c3aed'], ['500+', 'Campaigns Run', '#1e40af'],
              ['95%', 'Client Retention', '#059669'], ['50K+', 'Leads Generated', '#d97706'],
            ].map(([val, label, color], i) => (
              <div key={i} data-aos="fade-up" data-aos-delay={i * 80} style={{ padding: '1.5rem' }}>
                <div style={{ fontSize: '2rem', fontWeight: 900, background: 'var(--gradient-primary)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text' }}>{val}</div>
                <div style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', fontWeight: 500, marginTop: 4 }}>{label}</div>
              </div>
            ))}
          </div>
        </Container>
      </section>

      {/* Services */}
      <section className="section-py" style={{ background: 'var(--color-bg-alt)' }}>
        <Container>
          <div className="section-header text-center" data-aos="fade-up">
            <span className="section-badge">Our Services</span>
            <h2 className="section-title">Full-Spectrum <span>Digital Marketing</span></h2>
            <p className="section-subtitle">From brand awareness to conversion optimization — we cover every stage of the marketing funnel.</p>
          </div>
          <Row className="g-4">
            {SERVICES.map((s, i) => (
              <Col lg={4} md={6} key={i} data-aos="fade-up" data-aos-delay={i * 80}>
                <div className="vk-card" style={{ height: '100%' }}>
                  <div style={{ width: 52, height: 52, borderRadius: 13, background: `${s.color}12`, color: s.color, display: 'grid', placeItems: 'center', fontSize: '1.375rem', marginBottom: '1rem' }}>{s.icon}</div>
                  <h4 style={{ fontSize: '1.0625rem', fontWeight: 700, color: 'var(--color-text)', marginBottom: '0.5rem' }}>{s.title}</h4>
                  <p style={{ fontSize: '0.875rem', color: 'var(--color-text-muted)', lineHeight: 1.65 }}>{s.desc}</p>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="cta-section" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #3b0764 50%, #1e40af 100%)' }}>
        <Container className="text-center" data-aos="zoom-in">
          <h2 className="cta-title">Ready to <span>Grow Your Brand?</span></h2>
          <p className="cta-desc">Let PromoX be your growth engine. Get started with a free digital audit.</p>
          <Link to="/contact" className="btn-primary-vk">Free Digital Audit <FaArrowRight /></Link>
        </Container>
      </section>
    </div>
  );
};

export default PromoX;
